import React, { Component } from 'react'
import { List, Map } from 'immutable'
import { connect } from 'react-redux'

import { changeBlockLevel } from './actions'

function mapStateToProps(state, hocProps) {
    const blockAccessRightsPath = hocProps.blockAccessRightsPathFn(state, hocProps.blockKey)
    const blockAccessRights = state.getIn(blockAccessRightsPath, Map())

    const levels = blockAccessRights.get('availableLevels', List())

    const blocks = state.getIn(['ui', 'workspace', hocProps.module, hocProps.id, 'blocks'], Map())
    const defaultValue = blockAccessRights.get('defaultLevel', '0') || '0'
    const selectedLevel = blocks.getIn([hocProps.blockKey, 'level'], defaultValue)

    return {
        levels,
        selectedLevel,
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, { changeBlockLevel })
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
